import PlayerTimelineButton from './PlayerTimelineButton';

const AddScene = () => {
  return (
    <PlayerTimelineButton
      tooltipTitle="Add Scene"
      buttonId="new-timeline-add-scene-button"
      isDisabled
      onClick={() => {}}
      iconName="IconLayoutColumns"
    />
  );
};

export default AddScene;
